import * as _ from 'lodash';
import qs from 'qs';
import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { CategoriedIssuesFilterQuery, Category, ChangeStatusSummaryResponse } from '../../../../shared/issuesV2';

//  Actual function to fetch the change status summary
function fetchChangeStatusSummary(query: CategoriedIssuesFilterQuery<Category>) {
  const queryParams = qs.stringify(query);
  return get<ChangeStatusSummaryResponse>(`/api/v2/issues/compare/summaries?${queryParams}`);
}

/**
 * Unique identifier for the team query.
 */
export const getChangeStatusSummaryQueryKey = (query: CategoriedIssuesFilterQuery<Category>): QueryKey =>
  // We omit the changeStatus because it doesn't affect the summary counts.
  ['issues', 'compare', 'summaries', _.omit(query, 'scope.compareTo.changeStatus')];

/**
 * useTeams is a hook that fetches and returns the teams the
 * current user has access to from /api/teams.
 */
export default function useChangeStatusSummary(query: CategoriedIssuesFilterQuery<Category>) {
  return useQuery<ChangeStatusSummaryResponse>({
    queryKey: getChangeStatusSummaryQueryKey(query),
    queryFn: () => fetchChangeStatusSummary(query),
  });
}
